import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import columns from './Columns';
import CompanyDataTableDt from './CompanyDataTableDt';

const CompanyIndex = () => {
  const [moreData, setMoreData] = useState(false);
  return (
    <>
      <Row className="mt-4 mb-1">
        <Col>
          <h2 className="h2-dt mt-3">Empresas Vigentes</h2>
        </Col>
      </Row>
      <CompanyDataTableDt moreData={moreData} setMoreData={setMoreData} columns={columns} />
    </>
  );
};
export default CompanyIndex;
